import type * as React from 'react';
import { Tag } from '@verclam/ui-kit';
import UsageAssignmentCardRevertAction from '@UI/Pages/AiAssignments/Shared/UsageAssignmentCard/UsageAssignmentCardRevertAction';
import { css } from '@emotion/react';
import { theme } from '@Guidelines/Theme/theme';
import type ModelAssignmentView from '@UI/Store/AiConfiguration/Views/ModelAssignmentView';
import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';

const headerRowStyle = css`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
`;

const headerTitleGroupStyle = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	flex-wrap: nowrap;
	width: 100%;
`;

const usageTitleStyle = css`
	${theme.typography.cardTitle}
	margin: 0;
	color: ${theme.colors.ink};
`;

type Props = {
	readonly assignment: ModelAssignmentView;
	readonly scope: AssignmentScope;
	optionalPresentation: boolean;
};

const UsageAssignmentHeaderCard: React.FC<Props> = ({ assignment, scope, optionalPresentation }) => {
	return (
		<div css={headerRowStyle}>
			<div css={headerTitleGroupStyle}>
				<h3 css={usageTitleStyle}>{assignment.usage.label}</h3>
				{assignment.isUnconfigured && !optionalPresentation ? (
					<Tag value="À configurer" severity="danger" rounded css={{ whiteSpace: 'nowrap' }} />
				) : null}
			</div>
			<UsageAssignmentCardRevertAction assignment={assignment} scope={scope} />
		</div>
	);
};

export default UsageAssignmentHeaderCard;
